import axios from "axios";
import { ApiError } from "./ApiError";

import { readToken } from "./localsorage";
import { APP_CONSTANTS } from "../../constants/AppConstants";

export const baseURL = APP_CONSTANTS.base_url;
export const httpApi = axios.create({
  baseURL: baseURL,
});

httpApi.interceptors.request.use((config: any) => {
  if (config.url === "auth/token/" || config.url === "users/google/") {
    config.headers = {
      ...config.headers,
    };
  } else {
    config.headers = {
      ...config.headers,
      Authorization: `JWT ${readToken()}`,
    };
  }

  return config;
});

httpApi.interceptors.response.use(undefined, (error: any) => {
  throw new ApiError<ApiErrorData>(
    error && error.response?.data["message_description"]
      ? error.response?.data["message_description"]
      : error.message
  );
});

export interface ApiErrorData {
  message: string;
}
